<template>
  <div class="building-info-list">
    <buildingInfoCol
    v-for="(item, index) in infoList"
    :key="item.name"
    :showIndex="index"
    :info="item"/>
    <div class="more" @click="more">
      <div>联系我们查看更多</div>
      <img src="@/assets/images/gateway/more.png"/>
    </div>
  </div>
</template>

<script>
import BuildingInfoCol from '../home/buildingInfoCol.vue'
import infoList from './info'
export default {
  data () {
    return {
      infoList: infoList
    }
  },
  components: {
    BuildingInfoCol
  },
  methods: {
    more () {
      this.$router.push('/join')
    }
  }
}
</script>

<style lang="scss" scoped>
.building-info-list {
  .more {
    cursor: pointer;
    display: flex;
    background: #2D4978;
    color: #fff;
    height: 0.5rem;
    line-height: 0.5rem;
    font-size: 0.14rem;
    width: 2rem;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.5rem;
    img {
      width: 0.17rem;
      margin-left: 0.08rem;
    }
  }
}
</style>